/**
 * TanStack Query hooks for `datacenter-traffic-block-aws-gcp-azure-ip-blacklist`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	datacenterTrafficBlockAwsGcpAzureIpBlacklistQueryKeys,
	type CreateDatacenterTrafficBlockAwsGcpAzureIpBlacklistBody,
	type ListDatacenterTrafficBlockAwsGcpAzureIpBlacklistResponse,
	type DatacenterTrafficBlockAwsGcpAzureIpBlacklistRow,
} from "./api";

export function useDatacenterTrafficBlockAwsGcpAzureIpBlacklistList(): UseQueryResult<ListDatacenterTrafficBlockAwsGcpAzureIpBlacklistResponse, Error> {
	return useQuery({
		queryKey: datacenterTrafficBlockAwsGcpAzureIpBlacklistQueryKeys.list(),
		queryFn: list,
	});
}

export function useDatacenterTrafficBlockAwsGcpAzureIpBlacklistCreate(): UseMutationResult<DatacenterTrafficBlockAwsGcpAzureIpBlacklistRow, Error, CreateDatacenterTrafficBlockAwsGcpAzureIpBlacklistBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: datacenterTrafficBlockAwsGcpAzureIpBlacklistQueryKeys.all });
		},
	});
}

export function useDatacenterTrafficBlockAwsGcpAzureIpBlacklistDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: datacenterTrafficBlockAwsGcpAzureIpBlacklistQueryKeys.all });
		},
	});
}
